import { Spinner } from "@components/ui/Spinner"
import { FilmFinderFilm } from "@features/film-finder/filmfinder-store"
import { EventType } from "@generated-types"
import { isPastEvent } from "@utils/past-event"
import { useHydrating } from "eddev/routing"
import { defineView } from "eddev/views"
import { Suspense, useMemo } from "react"
import { dynamic } from "eddev/dynamic"
import "@features/film-finder/filmfinder.css"

const FilmFinder = dynamic(() => import("@features/film-finder/FilmFinder"), "film-finder")

export const meta: ViewMeta = {
  templateName: "Film Finder",
}

export default defineView("template-film-finder", (props) => {
  const films = useMemo(() => {
    return props.currentProgram?.films
      ?.filter(
        (film) => film?.eventInfo?.eventType === EventType.Film || film?.eventInfo?.eventType === EventType.Short,
      )
      ?.map(
        (film): FilmFinderFilm => ({
          ID: film?.databaseId!,
          slug: film?.uri!,
          title: film?.title!,
          abstract: film?.descriptions?.short!,
          classification: film?.eventInfo?.classification!,
          runtime: String(film?.eventInfo?.runtime!),
          trailer: film?.eventInfo?.trailer!,
          country: film?.filmInfo?.primaryCountry!,
          director: film?.credits?.director?.join(", ") ?? "",
          featured: false,
          images: film?.media?.gallery.map((item) => item.srcSet!) ?? [],
          thumb: film?.media?.thumb?.srcSet!,
          typeLabel: film?.eventInfo?.filmTypeLabel!,
          year: film?.filmInfo?.year!,
          stream: film?.eventInfo?.movieMatchCategory!,
          isPast: isPastEvent({ film: film! }),
        }),
      )!
  }, [props.currentProgram?.films])

  const loadingScreen = (
    <div className="film-finder theme-dark" data-mixpanel-area="Film Finder">
      <div className="-screen">
        <div className="w-grid mx-auto text-center flex items-center justify-center h-full">
          <div className="type-title-m text-fg flex flex-col items-center gap-2">
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  )

  const hydrating = useHydrating()

  if (!env.client || hydrating) return loadingScreen

  return (
    <Suspense fallback={loadingScreen}>
      <FilmFinder
        labels={{
          title: "Trailer<br />Roulette",
          homeDescription:
            "Need help choosing from the 200+ films on offer at SFF? Watch your way through a hand-picked stream of trailers. Give a thumbs up to the ones that catch your eye and build your shortlist as you go.",
          howToTitle: "How to play Trailer Roulette",
          howToDescription:
            "We'll cue up a trailer from the 200+ films screening at SFF. Love what you see? Thumbs up or swipe right to add it to your shortlist. Not your thing? Thumbs down or swipe left and we'll roll the next one. Keep spinning until you've got your picks — then send them straight to your planner or cart!",
          programLinkText:
            "Only <percentageWithTrailers> of our films have trailers! Want to see all <totalFilms> films in one spot?",
          getStartedButton: "Start Watching",
          trailersClarification: "",
        }}
        thumbnails={[]}
        films={films}
      />
    </Suspense>
  )
})
